import { Link } from './links';

export interface ShowCreator {
  id: string;
  name: string;
  link: string;
  role: string;
}

export interface ShowCore {
  itunesId: string;
  title: string;
  publisher: string;
  image: string;
  links: Link[];
}

export interface ShowBase extends ShowCore {
  id: string;
  vanityUrl?: string;
  // isClaimed: boolean;
  creators?: ShowCreator[];
  host: Host;
}
export interface ShowDb extends ShowBase {
  accountId?: string;
  isActive: boolean;
  createdBy: string;
  createdAt?: string;
  updatedAt?: string;
  canceledAt?: string;
}

export interface Host {
  name: string;
  url: string;
  isAffiliate: boolean;
}

export enum MoveDirection {
  UP = 'UP',
  DOWN = 'DOWN',
}
